/*
 * Copyright (c) 2021, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */

import React, {Fragment} from 'react'
import PropTypes from 'prop-types'
import {FormattedMessage} from 'react-intl'
import {Alert, Button, Stack, Text} from '@salesforce/retail-react-app/app/components/shared/ui'
import {AlertIcon} from '@salesforce/retail-react-app/app/components/icons'
import {noop} from '@salesforce/retail-react-app/app/utils/utils'
import TrackOrderFields from '../forms/track-order-fields'
import {pxToRem} from '../../utills/pxToRem'
import {trackOrderContainerStyle} from './index.style'

const TrackOrderForm = ({submitForm, form}) => {
    return (
        <Stack sx={trackOrderContainerStyle}>
            <Stack justify="center" align="center" spacing={{base: pxToRem(15), lg: pxToRem(25)}}>
                <Text as="h2">
                    <FormattedMessage
                        defaultMessage="Track My Order"
                        id="track_order_form.title.track_my_order"
                    />
                </Text>
                <Text>
                    <FormattedMessage
                        defaultMessage="Track your order without an account. Just enter your order number and billing ZIP Code."
                        id="track_order_form.description.track_your_order"
                    />
                </Text>
            </Stack>
            <form
                id="track-order-form"
                onSubmit={form.handleSubmit(submitForm)}
                data-testid="track-order-modal-form"
                noValidate
            >
                {form.formState.errors?.global && (
                    <Alert status="error" mb={{base: `${pxToRem(20)}`, lg: `${pxToRem(25)}`}}>
                        <AlertIcon color="red.500" boxSize={4} />
                        <Text fontSize="sm" ml={3}>
                            {form.formState.errors.global.message}
                        </Text>
                    </Alert>
                )}
                <TrackOrderFields form={form} submitForm={submitForm} />
                <Button
                    variant="red"
                    type="submit"
                    onClick={() => form.clearErrors('global')}
                    isLoading={form.formState.isSubmitting}
                >
                    <FormattedMessage
                        defaultMessage="Find my order"
                        id="track_order_form.submit.find_my_order"
                    />
                </Button>
            </form>
        </Stack>
    )
}

TrackOrderForm.propTypes = {
    submitForm: PropTypes.func,
    form: PropTypes.object
}

export default TrackOrderForm
